import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthTemplate } from '../components';
import EventLocationForm from '../components/create-event/event-location/EventLocationForm';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { getResponsiveStyle } from '../utils/getResponsiveStyle';
import { setCurrentScreen } from '../redux/uiSlice';

const EventLocationScreen = () => {
	const { t } = useTranslation();
	const createEventSidebarArray = useAppSelector(
		state => state.ui.CreateEventSidebarArray
	);
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(setCurrentScreen('/event-location'));
	}, []);
	return (
		<AuthTemplate
			heading={t('Add Location')}
			subText={t('Help individuals find the venue?')}
			scrollItems={createEventSidebarArray}
			contentStyles={{ marginTop: getResponsiveStyle(100) }}
		>
			<EventLocationForm />
		</AuthTemplate>
	);
};

export default EventLocationScreen;
